import useRouter from '../useRouter';
import { PageType } from './types';
import { getPageTypeByUrl } from './pageTypeService';

export const bellaPageTypes = [
    PageType.ALLPRODUCTS,
    PageType.NEWPRODUCTS,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.CATEGORY,
    PageType.STYLES,
    PageType.HOMEPAGE,
    PageType.PDP,
];

const useCurrentPageType = () => {
    const {
        location: { pathname },
        host,
    } = useRouter();

    return getPageTypeByUrl(pathname, host);
};

const useIsBellaPageType = () => {
    const { host } = useRouter();

    return (url: string) => {
        const { pageType, relativeUrl } = getPageTypeByUrl(url, host);
        return { isBellaPage: bellaPageTypes.includes(pageType), relativeUrl };
    };
};

export { useCurrentPageType, useIsBellaPageType, PageType };
